import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import listViewStore from '../store/Store';
import getIsEverythingSelectedInTable from './getIsEverythingSelectedInTable';
import isItemPartOperation from './isItemPartOperation';
export default function getItemsOrConversationsSelectedText(tableViewId) {
    var mainText;
    var tableView = listViewStore.tableViews.get(tableViewId);
    if (getIsEverythingSelectedInTable(tableView)) {
        if (tableView.virutalSelectAllExclusionList.length > 0) {
            mainText = format(strings.someItemsSelected, tableView.totalRowsInView - tableView.virutalSelectAllExclusionList.length);
        }
        else {
            mainText = strings.everythingSelected;
        }
    }
    else {
        var selectedString = tableView.tableQuery.listViewType == 1 /* Message */ || isItemPartOperation()
            ? strings.someItemsSelected
            : strings.someConversationsSelected;
        mainText = format(selectedString, isItemPartOperation()
            ? listViewStore.expandedConversationViewState.selectedNodeIds.length
            : tableView.selectedRowKeys.size);
    }
    return mainText;
}
//# sourceMappingURL=getItemsOrConversationsSelectedText.js.map